<template>
    <div id="pay_charge">
        <div class="accordion accordion-toggle-arrow" id="userFilter">
            <div class="card" style="overflow:inherit">
                <div class="card-header bg-transparent" id="headingOne">
                    <div class="card-title collapsed" data-toggle="collapse"
                         data-target="#filterForm"
                         aria-controls="filterForm">
                        {{ $t('label.search') }}
                    </div>
                </div>
                <kt-panel>
                    <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#userFilter">
                        <div class="card-body">
                            <form @submit.prevent="filterAction($event, query)" id="transaction_form_filter">
                                <kt-form-section>
                                    <kt-form-row>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <kt-form-group ref="typeSelectGroup">
                                                <kt-form-label for="type">
                                                    {{ $t('label.type') }}
                                                </kt-form-label>
                                                <kt-form-select size="5" id="type" class="form-control"
                                                                name="type" v-model="query.type"
                                                >
                                                    <option :value="null" v-text="$t('label.all_charge_types')"
                                                    ></option>
                                                    <option :value="walletTransactionType.CHARGE_BY_BILL"
                                                            v-text="walletTransactionTypeStr.get(walletTransactionType.CHARGE_BY_BILL)"
                                                    ></option>
                                                    <option :value="walletTransactionType.CHARGE_BY_TRANSFER"
                                                            v-text="walletTransactionTypeStr.get(walletTransactionType.CHARGE_BY_TRANSFER)"
                                                    ></option>
                                                    <option :value="walletTransactionType.CHARGE_BY_COLLECTIVE_TO_WALLET"
                                                            v-text="walletTransactionTypeStr.get(walletTransactionType.CHARGE_BY_COLLECTIVE_TO_WALLET)"
                                                    ></option>
                                                    <option :value="walletTransactionType.CHARGE_BY_DIRECT_PAYMENT"
                                                            v-text="walletTransactionTypeStr.get(walletTransactionType.CHARGE_BY_DIRECT_PAYMENT)"
                                                    ></option>
                                                    <option :value="walletTransactionType.CHARGE_BY_OAUTH2"
                                                            v-text="walletTransactionTypeStr.get(walletTransactionType.CHARGE_BY_OAUTH2)"
                                                    ></option>
                                                    <option :value="walletTransactionType.CHARGE_BY_IVR_TRANSACTION"
                                                            v-text="walletTransactionTypeStr.get(walletTransactionType.CHARGE_BY_IVR_TRANSACTION)"
                                                    ></option>
                                                    <option :value="walletTransactionType.CHARGE_BY_MARKETING_PROFIT"
                                                            v-text="walletTransactionTypeStr.get(walletTransactionType.CHARGE_BY_MARKETING_PROFIT)"
                                                    ></option>
                                                    <option :value="walletTransactionType.CHARGE_BY_SETTLEMENT_REVERSAL"
                                                            v-text="walletTransactionTypeStr.get(walletTransactionType.CHARGE_BY_SETTLEMENT_REVERSAL)"
                                                    ></option>
                                                    <option :value="walletTransactionType.CHARGE_BY_RECEIPT"
                                                            v-text="walletTransactionTypeStr.get(walletTransactionType.CHARGE_BY_RECEIPT)"
                                                    ></option>
                                                    <option :value="walletTransactionType.CHARGE_BY_RECEIPT_FINALLY"
                                                            v-text="walletTransactionTypeStr.get(walletTransactionType.CHARGE_BY_RECEIPT_FINALLY)"
                                                    ></option>
                                                    <option :value="walletTransactionType.CHARGE_BY_RECEIPT_THROUGH_AFFILIATE_MARKETER"
                                                            v-text="walletTransactionTypeStr.get(walletTransactionType.CHARGE_BY_RECEIPT_THROUGH_AFFILIATE_MARKETER)"
                                                    ></option>
                                                    <option :value="walletTransactionType.CHARGE_BY_COLLECTIVE_ON_PAYMENT_HELPER_TO_WALLET"
                                                            v-text="walletTransactionTypeStr.get(walletTransactionType.CHARGE_BY_COLLECTIVE_ON_PAYMENT_HELPER_TO_WALLET)"
                                                    ></option>
                                                    <option :value="walletTransactionType.CHARGE_THROUGH_SHAPARAK_SETTLEMENT"
                                                            v-text="walletTransactionTypeStr.get(walletTransactionType.CHARGE_THROUGH_SHAPARAK_SETTLEMENT)">
                                                    </option>
                                                    <option :value="walletTransactionType.CHARGE_BY_ALLOTMENT_PF_AGGREGATE"
                                                            v-text="walletTransactionTypeStr.get(walletTransactionType.CHARGE_BY_ALLOTMENT_PF_AGGREGATE)"
                                                    ></option>
                                                    <option :value="walletTransactionType.CHARGE_BY_DEPOSIT_WITH_ID"
                                                            v-text="walletTransactionTypeStr.get(walletTransactionType.CHARGE_BY_DEPOSIT_WITH_ID)"
                                                    ></option>
                                                    <option :value="walletTransactionType.CHARGE_BY_OPEN_BANKING_MARKETING_PROFIT"
                                                            v-text="walletTransactionTypeStr.get(walletTransactionType.CHARGE_BY_OPEN_BANKING_MARKETING_PROFIT)"
                                                    ></option>
                                                </kt-form-select>
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <kt-form-group ref="statusSelectGroup">
                                                <kt-form-label for="status">
                                                    {{ $t('label.status') }}
                                                </kt-form-label>
                                                <kt-form-select size="5" id="status" class="form-control"
                                                                name="status" v-model="query.status"
                                                >
                                                    <option :value="null" v-text="$t('label.all_statuses')"
                                                    ></option>
                                                    <option :value="walletTransactionStatus.PENDING"
                                                            v-text="walletTransactionStatusStr.get(walletTransactionStatus.PENDING)"
                                                    ></option>
                                                    <option :value="walletTransactionStatus.SUCCESS"
                                                            v-text="walletTransactionStatusStr.get(walletTransactionStatus.SUCCESS)"
                                                    ></option>
                                                    <option :value="walletTransactionStatus.FAILED"
                                                            v-text="walletTransactionStatusStr.get(walletTransactionStatus.FAILED)"
                                                    ></option>
                                                    <option :value="walletTransactionStatus.CHARGE_PENDING"
                                                            v-text="walletTransactionStatusStr.get(walletTransactionStatus.CHARGE_PENDING)"
                                                    ></option>
                                                </kt-form-select>
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <kt-form-group>
                                                <kt-form-label for="from_date">
                                                    {{ $t('label.from_date') }}
                                                </kt-form-label>
                                                <button id="reset_from_date"
                                                        @click="clearFromDate"
                                                        class=" btn btn-label-danger trash-btn"
                                                >
                                                    <i class="la la-trash-o"></i>
                                                </button>
                                                <datePicker
                                                        format="YYYY-MM-DD HH:mm:ss"
                                                        display-format="dddd jDD jMMMM jYYYY HH:mm"
                                                        input-class="form-control"
                                                        id="from_date"
                                                        name= "from_date"
                                                        v-model="query.from_date"
                                                        type="datetime" />
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <kt-form-group>
                                                <kt-form-label for="to_date">
                                                    {{ $t('label.to_date') }}
                                                </kt-form-label>
                                                <button id="reset_to_date"
                                                        @click="clearToDate"
                                                        class=" btn btn-label-danger trash-btn"
                                                >
                                                    <i class="la la-trash-o"></i>
                                                </button>
                                                <datePicker
                                                        format="YYYY-MM-DD HH:mm:ss"
                                                        display-format="dddd jDD jMMMM jYYYY HH:mm"
                                                        input-class="form-control"
                                                        id="to_date"
                                                        name= "to_date"
                                                        v-model="query.to_date"
                                                        type="datetime"
                                                />
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2" v-show="!prop_user_hashid">
                                            <label for="user_id"
                                                   v-text="$t('label.user_id')"
                                            >
                                            </label>
                                            <input type="text"
                                                   id="user_id"
                                                   name= "user_id"
                                                   class="form-control"
                                                   v-model="query.user_id"
                                            >
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <label for="wallet_hashid"
                                                   v-text="$t('label.wallet_hashid')"
                                            >
                                            </label>
                                            <input type="text"
                                                   id="wallet_hashid"
                                                   name= "wallet_hashid"
                                                   class="form-control"
                                                   v-model="query.wallet_hashid"
                                            >
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <label for="min_amount"
                                                   v-text="$t('label.min_amount')"
                                            >
                                            </label>
                                            <input type="text"
                                                   id="min_amount"
                                                   name= "min_amount"
                                                   class="form-control"
                                                   v-model="query.min_amount"
                                            >
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <label for="max_amount"
                                                   v-text="$t('label.max_amount')"
                                            >
                                            </label>
                                            <input type="text"
                                                   id="max_amount"
                                                   name= "max_amount"
                                                   class="form-control"
                                                   v-model="query.max_amount"
                                            >
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <label for="dargah_transaction_id"
                                                   v-text="$t('label.dargah_transaction_id')"
                                            >
                                            </label>
                                            <input type="text"
                                                   id="dargah_transaction_id"
                                                   name= "dargah_transaction_id"
                                                   class="form-control"
                                                   v-model="query.dargah_transaction_id"
                                            >
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <label for="transaction_hashid"
                                                   v-text="$t('label.transaction_hashid')"
                                            >
                                            </label>
                                            <input type="text"
                                                   id="transaction_hashid"
                                                   name= "transaction_hashid"
                                                   class="form-control"
                                                   v-model="query.transaction_hashid"
                                            >
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <label for="detected_type"
                                                   v-text="$t('label.detected_type')"
                                            >
                                            </label>
                                            <select id="detected_type"
                                                    class="form-control"
                                                    v-model="query.detected_type"
                                            >
                                                <option :value="null"></option>
                                                <option v-text="$t('label.reversed_automatically')" value="0"></option>
                                                <option v-text="$t('label.reversed_by_admin')" value="1"></option>
                                            </select>
                                        </kt-col>
                                    </kt-form-row>
                                </kt-form-section>
                                <kt-form-section>
                                    <kt-row>
                                        <kt-col xs="12" sm="6" md="6" class="mt-4">
                                            <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                                            <button id="transaction_excel_export" type="button" class="btn btn-success btn-wide mx-4" @click="exportToExcel">{{ $t('label.excel_export') }}</button>
                                        </kt-col>
                                    </kt-row>
                                </kt-form-section>
                            </form>
                        </div>
                    </div>
                </kt-panel>
            </div>
        </div>
        <div class="row my-2">
            <div class="col-6">
                <transactionStat
                        :transactionStatistics="success_tr_amount_sum"
                        :title="$t('label.total_succeed_charge_amount')"
                        :needCurrency="true"
                />
            </div>
            <div class="col-6">
                <transactionStat
                        :transactionStatistics="success_tr_count"
                        :title="$t('label.succeeded_charge_count')"
                        :needCurrency="false"
                />
            </div>
<!--            <div class="col-3">-->
<!--                <transactionStat-->
<!--                        :transactionStatistics="transfer_success_tr_amount_sum"-->
<!--                        :title="$t('label.total_succeed_transfer_transactions_amount')"-->
<!--                        :needCurrency="true"-->
<!--                />-->
<!--            </div>-->
<!--            <div class="col-3">-->
<!--                <transactionStat-->
<!--                        :transactionStatistics="transfer_success_tr_count"-->
<!--                        :title="$t('label.succeeded_transfer_transactions_count')"-->
<!--                        :needCurrency="false"-->
<!--                />-->
<!--            </div>-->
        </div>
        <kt-datatable ref="datatable" v-bind="datatableProps">
        </kt-datatable>
    </div>
</template>

<script>
import {ApiUrl, authService, walletService} from "@/common/api.service";
    import {AuthorizationHeader} from "@/common/jwt.service";
    import columns from "../datatable/transaction-columns.js";
    import actions from "../datatable/adminDetermineUnknownActions";
    import {walletTransactionStatus, walletTransactionStatusStr} from "@/constants/walletTransactionStatus";
    import {walletTransactionType, walletTransactionTypeStr} from "@/constants/walletTransactionType";
    import transactionStat from '@/views/transaction/components/transaction-statistic'
    import $ from 'jquery'
    import { KTApp } from '@/plugins/core/app'
    import axios from "axios";
import {i18n} from "@/plugins/i18n";


    export default {
        components: {
            transactionStat,
        },
        data() {
            return {
                query: {
                    user_id: this.prop_user_hashid
                },
                walletTransactionStatus,
                walletTransactionStatusStr,
                walletTransactionType,
                walletTransactionTypeStr,
                success_tr_count: 0,
                success_tr_amount_sum: 0,
                transfer_success_tr_amount_sum: 0,
                transfer_success_tr_count: 0,
            };
        },
        mounted() {
            this.loadStats();
        },
        props: {
            prop_user_hashid : {
                required : false
            },
            fetch_starshop: {
                default: false,
                type: Boolean
            },
            api_base_path: {
                default: ApiUrl.path(''),
                type: String
            }
        },
        methods: {
            loadStats() {
              console.log('edoo')
              walletService.adminGetCoreTransactionsStats('A', this.query).then(res => {
                    const { success_tr_count, success_tr_amount_sum, transfer_success_tr_amount_sum, transfer_success_tr_count } = res.data.data;
                    
                    this.success_tr_count = success_tr_count;
                    this.success_tr_amount_sum = success_tr_amount_sum;
                    this.transfer_success_tr_amount_sum = transfer_success_tr_amount_sum;
                    this.transfer_success_tr_count = transfer_success_tr_count;
                });
            },

            filterAction(e, query) {
                this.query = query;

                if (this.$refs.datatable.KTDatatable) {
                    this.$refs.datatable.reload();
                }

                this.loadStats();
            },
            clearFromDate() {
                if (this.query.from_date) {
                    this.query.from_date = null;
                }
            },
            clearToDate() {
                if (this.query.to_date) {
                    this.query.to_date = null;
                }
            },
            exportToExcel(e){
                let form = $('#transaction_form_filter')
                let btn = $('#transaction_excel_export')

                if(!form.valid()) {
                    return
                }

                if (this.prop_user_hashid !== undefined){
                    this.query.user_id = this.prop_user_hashid;
                }


                if (this.query.type !== null){
                    this.query.transaction_type = this.query.type;
                }
                KTApp.progress(btn)
                axios({
                    url: ApiUrl.path('wallet/common/admin/transactions-excel-report'),
                    method: 'GET',
                    params: {query: this.query},
                    responseType: 'blob',
                })
                    .then((response) => {
                        let fileURL = window.URL.createObjectURL(new Blob([response.data]));
                        let fileLink = document.createElement("a");

                        fileLink.href = fileURL;
                        fileLink.setAttribute("download", "Transactions.xlsx");
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        KTApp.unprogress(btn)
                    })
                    .catch(({response}) => {
                        KTApp.unprogress(btn)
                        this.toastr.error(response.data.message)
                    })
                    .finally(()=>{
                        delete this.query.transaction_type;
                    })
            },

        },
        computed: {
            datatableProps() {
                return {
                    id: "wallets_transactions_datatable",
                    data: {
                        type: 'remote',
                        source: {
                            read: {
                                url: ApiUrl.path('wallet/common/admin/transactions/A'),
                                method: 'GET',
                                headers: AuthorizationHeader,
                                map: res => {
                                    return res.data.data;
                                },
                                params: {
                                    query: this.query,
                                },
                            }
                        },
                        pageSize: 10,
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                    },
                    layout: {},
                    pagination: false,
                    sortable: true,
                    columns: columns,
                    actions: actions,
                }
            },
        },
    }
</script>
